<template>
  <div>
    <div class="md-layout md-alignment-center-right">
      <div class="md-layout-item md-size-30">
        <md-field md-clearable md-inline>
          <label>输入设备序列号按回车键搜索</label>
          <md-input v-model="filterDeviceSn" @keyup.enter="search(filterDeviceSn)"></md-input>
        </md-field>
      </div>
    </div>

    <h1 class="md-title">过量授权设备</h1>

    <md-table>
      <md-table-toolbar>
        <div class="md-toolbar-section-end" id="toolbar_show" v-show="selectedDevices.length !== 0">
          <md-button class="md-primary" @click="allowPass(false)">启用限制</md-button>
          <md-button class="md-primary" @click="allowPass(true)">取消限制</md-button>
        </div>
      </md-table-toolbar>
      <md-table-row>
        <md-checkbox v-model="allSelected" @change="selectAll"></md-checkbox>
        <md-table-head class="table_head">序号</md-table-head>
        <md-table-head class="table_head">所属公司</md-table-head>
        <md-table-head class="table_head">设备序列号</md-table-head>
        <md-table-head class="table_head">已激活数</md-table-head>
        <md-table-head class="table_head">最大允许激活数</md-table-head>
        <md-table-head class="table_head">是否启用限制</md-table-head>
        <md-table-head class="table_head">操作</md-table-head>
      </md-table-row>

      <md-table-row
          v-for="(item, index) in warningsDevices"
          v-bind:key="item.sn">
        <md-checkbox v-model="selectedDevices" v-bind:value="warningsDevices[index].device_id"
                     @change="changeSelect"></md-checkbox>
        <md-table-cell>{{ (index + 1) }}</md-table-cell>
        <md-table-cell>{{ item.company_name }}</md-table-cell>
        <md-table-cell>{{ item.sn }}</md-table-cell>
        <md-table-cell>{{ item.active_num }}</md-table-cell>
        <md-table-cell>{{ item.allow_num }}</md-table-cell>
        <md-table-cell>{{ item.allow_pass ? '未启用' : '已启用' }}</md-table-cell>
        <md-table-cell>
          <md-button class="md-accent" @click="showModifyWarningDialog(item)">
            修改
          </md-button>
          <md-button class="md-accent" @click="lockUnlockDevice(item.company_id, item.sn, !item.device_freeze)">
            {{ item.device_freeze ? '已冻结' : '正常' }}
          </md-button>
        </md-table-cell>
      </md-table-row>

    </md-table>

    <div class="md-layout md-alignment-center-right">
      <md-button @click="gotoPageAt(page - 1)">上一页</md-button>
      <md-button @click="gotoPageAt(parseInt(page) + 1)">下一页</md-button>
      总计{{ Math.floor(total / count) + (total % count === 0 ? 0 : 1) }}页，当前第{{ page }}页

      <div class="md-layout-item md-size-15">
        <md-field>
          <label for="count">每页显示条数</label>
          <md-select v-model="count" name="count" id="count" @md-selected="getWarnings">
            <md-option value="15">每页显示15条</md-option>
            <md-option value="30">每页显示30条</md-option>
            <md-option value="60">每页显示60条</md-option>
            <md-option value="100">每页显示100条</md-option>
            <md-option value="200">每页显示200条</md-option>
          </md-select>
        </md-field>
      </div>

      <div class="md-layout-item md-size-10" id="page_input">
        <md-field md-inline md-clearable>
          <label>输入页数</label>
          <md-input v-model="goPage" type="number"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-10" id="device_page">
        <md-button class="md-accent md-raised md-dense" @click="gotoPage">跳转</md-button>
      </div>
    </div>

    <md-dialog :md-active.sync="showModifyWarning">
      <md-dialog-title>修改报警数据</md-dialog-title>
      <div class="md-layout">
        <div class="md-layout-item">
          <md-field>
            <label>最大允许激活数</label>
            <md-input v-model="newAllowNumber" type="number"></md-input>
          </md-field>
        </div>

      </div>
      <div class="md-layout">
        <div class="md-layout-item">
          <md-checkbox v-model="newNotAllowPass">启用限制</md-checkbox>
        </div>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showModifyWarning = false">取消</md-button>
        <md-button class="md-primary" @click="modifyWarningSettings">确定</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-snackbar :md-active.sync="toast">{{ toastMsg }}</md-snackbar>
  </div>
</template>

<script>
export default {
  name: "WarningsDevices",
  data: () => ({
    warningsDevices: [],
    warningToModify: null,
    showModifyWarning: false,
    newAllowNumber: 0,
    newNotAllowPass: true,
    toast: false,
    toastMsg: "",
    page: 1,
    goPage: '',
    total: 0,
    count: 15,
    filterDeviceSn: null,
    allSelected: false,
    selectedDevices: [],
  }),
  mounted() {
    this.getWarnings();
  },
  methods: {
    gotoPage: function () {
      if (this.goPage) {
        this.page = this.goPage;
        this.getWarnings();
      } else {
        this.showErrorTips('请输入页数');
      }
    },
    gotoPageAt: function (p) {
      if (p <= 0) p = 1;
      this.page = p;
      this.getWarnings();
    },
    modifyWarningSettings: function () {
      this.$http.put('/api/device/warning/' + this.warningToModify.device_id + "/" + this.newAllowNumber + '/' + !this.newNotAllowPass + '/').then(
          response => {
            this.showModifyWarning = false;
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.showTips('修改成功');
                this.getWarnings();
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('获取失败，服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        this.showModifyWarning = false;
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    showModifyWarningDialog: function (item) {
      this.showModifyWarning = true;
      this.newAllowNumber = item.allow_num;
      this.newNotAllowPass = !item.allow_pass;
      this.warningToModify = item;
    },
    getWarnings: function () {
      this.$http.get('/api/device/warnings/?page=' + this.page + "&count=" + this.count).then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.total = data.data.total;
                this.warningsDevices = data.data.warnings;

                this.allSelected = false;
                this.selectedDevices.splice(0);
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('获取失败，服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    search: function (sn) {
      if (!sn) {
        this.getWarnings();
        return;
      }
      this.$http.get('/api/device/warnings/' + sn + "/").then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.total = data.data.total;
                this.warningsDevices = data.data.warnings;

                this.allSelected = false;
                this.selectedDevices.splice(0);
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('获取失败，服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    lockUnlockDevice: function (company_id, sn, freeze) {
      this.$http.post('/api/device/freeze/' + company_id + "/" + sn + '/' + freeze + '/').then(response => {
        if (response.status === 200) {
          let data = response.data;
          if (data.code === 0) {
            this.getWarnings();
          } else {
            this.showErrorTips('修改失败，服务器返回错误码' + data.code);
          }
        } else {
          this.showErrorTips('修改失败，HTTP错误码' + response.status);
        }
      }).catch(error => {
        this.showErrorTips('未知错误' + error);
      })
    },
    allowPass: function (allow) {
      this.$http.put('/api/device/warning-batch/' + '-1' + '/' + allow + '/', this.selectedDevices).then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.showTips('修改成功');
                this.getWarnings();
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('获取失败，服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    changeSelect: function () {
      this.allSelected = this.selectedDevices.length === this.warningsDevices.length;
    },
    selectAll: function () {
      if (this.allSelected) {
        this.selectedDevices.splice(0);
        for (let i = 0; i < this.warningsDevices.length; i++) {
          this.selectedDevices.push(this.warningsDevices[i].device_id);
        }
      } else {
        this.selectedDevices.splice(0);
      }
    },
    showTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
    showErrorTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
  }
}
</script>

<style scoped>
.table_head {
  text-align: center;
}

.md-layout-item {
  padding: 0 20px;
}

#toolbar_show {
  background: antiquewhite;
}
</style>